export default class BaseService {
    
    static async callAPI(url, data) {
        const headers = {
            'Content-Type': 'application/json'
        };
        const response = await fetch('/api/' + url, {
            method: 'POST',
            headers,
            body: (data ? JSON.stringify(data) : null)
        });

        if (data && data.isDownload) {
            if (!data.fileName) {
                const contentDisposition = response.headers.get('content-disposition');
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+?)"/);
                    if (match) {
                        data.fileName = match[1];
                    }
                }
            }

            const blob = await response.blob();

            var a = document.createElement('a');
            a.style = 'display: none';
            document.body.appendChild(a);
            try {
                a.href = window.URL.createObjectURL(blob);
                a.download = data.fileName;
                a.click();
            } finally {
                setTimeout(() => {
                    window.URL.revokeObjectURL(blob);
                    a.remove();
                }, 100);
            }

        } else {

            const text = await response.text();
            if (response.status == 404) {
                throw 'API CALL 404 (' + url + ')';
            } else if (text.length > 0) {
                const responseObject = JSON.parse(text);
                if (responseObject.success) {
                    return responseObject.content;
                } else {
                    throw responseObject.content; // Error message
                }
            } else {
                return null;
            }
        }
    }

    static async postFile(url, file, data) {
        // Create form data object
        var formData = new FormData();
        formData.append('file', file);
        if (data) {
            for (var key in data) {
                formData.append(key, data[key])
            }
        }

        // Do the upload
        const response = await fetch('/api/' + url, {
            method: 'POST',
            body: formData
        });
        
        const text = await response.text();
        if (response.status == 404) {
            throw 'API CALL 404 (' + url + ')';
        } else if (text.length > 0) {
            const responseObject = JSON.parse(text);
            if (responseObject.success) {
                return responseObject.content;
            } else {
                throw responseObject.content; // Error message
            }
        } else {
            return null;
        }
    }

    //static handleAJAXError(response) {
    //    if (response.success) {
    //        return true;
    //    } else {

    //    }
    //}
}